import React, { useState } from "react";
import {
  TextField,
  Popover,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  InputAdornment,
} from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  popover: {
    width: "200px",
    maxHeight: "400px",
  },
  listItem: {
    padding: theme.spacing(1, 2),
  },
  input: {
    cursor: "pointer",
  },
}));

interface CustomTimePickerProps {
  value: string;
  onChange: (time: string) => void;
  label: string;
  disabled?: boolean;
  helperText?: string;
}

const CustomTimePicker = ({
  value,
  onChange,
  label,
  disabled = false,
  helperText,
}: CustomTimePickerProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTimeSelect = (time: string) => {
    onChange(time);
    handleClose();
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = `${hour
          .toString()
          .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        options.push(time);
      }
    }
    return options;
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TextField
        label={label}
        value={value}
        onClick={handleClick}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDown />
            </InputAdornment>
          ),
          className: classes.input,
        }}
        disabled={disabled}
        fullWidth
        margin="dense"
        helperText={helperText}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        marginThreshold={2}
      >
        <List className={classes.popover}>
          {generateTimeOptions().map((time) => (
            <ListItem
              button
              onClick={() => handleTimeSelect(time)}
              key={time}
              className={classes.listItem}
            >
              <ListItemText primary={time} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default CustomTimePicker;
